import { Toast as BaseUIToast, type ToastManagerAddOptions } from '@base-ui/react/toast';
import { useEffect, useMemo, useRef } from 'react';

import type { ToastData, ToastOptions, UseToastReturnValue } from './useToast.types';

export const useToast = (): UseToastReturnValue => {
  const { toasts, add, update, close } = BaseUIToast.useToastManager();
  // Read through a ref so the returned object stays stable while toasts come and go.
  const toastsRef = useRef(toasts);

  useEffect(() => {
    toastsRef.current = toasts;
  }, [toasts]);

  return useMemo(
    () => ({
      add: ({ color = 'primary', icon, ...toast }: ToastOptions) => {
        const options: ToastManagerAddOptions<ToastData> = {
          ...toast,
          priority: color === 'danger' ? 'high' : 'low',
          data: { color, icon },
        };
        const isShown = toastsRef.current.some(
          ({ id, transitionStatus }) => id === toast.id && transitionStatus !== 'ending',
        );

        if (toast.id && isShown) {
          update<ToastData>(toast.id, options);
          return toast.id;
        }
        return add<ToastData>(options);
      },
      close,
    }),
    [add, update, close],
  );
};
